import React, { createContext, useEffect, useState } from "react";
//Create context
export const CartContext = createContext();

const CartProvider = ({ children }) => {
  const [IsOpen, setIsOpen] = useState(false);
  const [cart, setCart] = useState([]);
  const [itemsAmount, setItemsAmount] = useState(0);
  const [amount, setAmount] = useState(0);
  const [total, setTotal] = useState(0);
  // cart amount
  useEffect(() => {
    const amount = cart.reduce((a, c) => {
      return a + c.amount;
    }, 0);
    setItemsAmount(amount);
  }, [cart]);
  //add to cart
  const addToCart = (item, id) => {
    const itemID = parseInt(id);
    const newItem = { ...item[0], amount: 1 };
    setCart([...cart, newItem]);
    //check if item is already in the cart
    const cartItem = cart.find((item) => {
      return item.id === itemID;
    });
    if (cartItem) {
      const newCart = cart.map((item) => {
        if (item.id === itemID) {
          setAmount(cartItem.amount + 1);
          return { ...item, amount: cartItem.amount + 1 };
        } else {
          return item;
        }
      });
      setCart(newCart);
    } else {
      setCart([...cart, newItem]);
    }
    // open the cart
    setIsOpen(true);
  };
  // removeFormCart
  const removeFromCart = (id) => {
    const newCart = cart.filter((item) => {
      return item.id !== id;
    });
    setCart(newCart);
  };
// handle input
  const handleInput = (e, id) => {
    let value = parseInt(e.target.value);
    const cartItem = cart.find((item) => item?.id == id);
    setCart(cart.map(item => 
      item?.id === id ? { ...item, amount: isNaN(value) ? 1 : value } : item
    ));
    setAmount(isNaN(value) ? 1 : value);
    setIsOpen(true)
   

  };
  // handle select
  const handleSelect = (e,id)=>{
    let value = parseInt(e.target.value);
    if (isNaN(value) || value <= 0) value = 1;
  
    const updatedCart = cart.map(item => {
      if (item.id === id) {
        return { ...item, amount: value };
      }
      return item;
    });
  
    setCart(updatedCart);
  
    const cartItem = updatedCart.find(item => item.id === id);
    
    
  }
  return (
    <CartContext.Provider
      value={{
        IsOpen,
        setIsOpen,
        addToCart,
        cart,
        removeFromCart,
        itemsAmount,
        handleInput,
        handleSelect
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
